import { twMerge } from 'tailwind-merge';
import { MainLayout } from 'root/src/client/v2/common/layouts/MainLayout';
export const BlackLayout = ({ children, className }) => {
    return (<div className={twMerge('bg-black w-full flex justify-center', className)}>
			<MainLayout>
				{children}
			</MainLayout>
		</div>);
};
